import axios from "axios";
import {
  addDoc,
  arrayUnion,
  collection,
  doc,
  getDocs,
  onSnapshot,
  query,
  setDoc,
  Timestamp,
  where,
  updateDoc,
  getDoc,
} from "firebase/firestore"; // Import Firestore functions
import { defineStore } from "pinia";
import { GoogleGenerativeAI } from "@google/generative-ai";
const gapiKey = "AIzaSyBQaXA4dRi8QWERa4KwSR2ulcGseGzyyII";
const genAI = new GoogleGenerativeAI(gapiKey);

export const usePersonaStore = defineStore("Persona", {
  

  state: () => ({
    form: {
      name: "",
      email: "",
      jobTitle: "",
      dateOfMove: "",
      moveOutDate: "",
      numberOfRooms: 1,
      numberOfBedrooms: 1,
      additionalSupport: "",
      household: {
        numberOfAdults: 1,
        numberOfKids: 0,
        childrenAges: [],
        pets: [],
      },
      property: {
        SearchType: "ForRent",
        propertyType: "",
        minBedrooms: 1,
        maxBedrooms: 4,
        minBathrooms: 1,
        maxBathrooms: 3,
        minSize: 500,
        maxSize: 3000,
        minBudget: 0,
        maxBudget: 0,
      },
      movingServices: {
        packingHelpNeeded: false,
        storageUnitNeeded: false,
        specialRequirements: "",
      },
      movingTo: {
        detailed_address: [],
      },
      neighborhoodPreferences: {
        type: "",
        communityType: "",
        amenities: {
          schools: 1,
          parks: 1,
          publicTransport: 1,
          shopping: 1,
          other: "",
          socialMix: "any",
          desiredIncomeLevel: null,
          ageRangePreference: null,
        },
      },
      preferredLocations: {
        location1: {
          commuteType: "car",
        },
        location2: {
          commuteType: "car",
        },
        location3: {
          commuteType: "car",
        },
      },
      aiPreferences: {
        enableAdvancedSearch: false,
        rentBudgetSpecifics: {
          rentTolerance: "",
        },
        commutePreferences: {
          maxCommuteTime: "",
          otherLocations: "",
        },
        floorplanPreferences: {
          layoutStyle: "",
          roomPriorities: [],
        },
        visualPreferences: {
          imagePriorities: [],
          stylePreference: "",
          inspirationImages: [],
        },
        dealBreakers: {
          nonNegotiables: "",
          flexibilityAreas: "",
        },
      },
    },
    originalFormState: null,
    changedFields: [],
    assumptions: "",
    personadocid: "",
    isoChrone: {},
    error: null,
    isFormDataComplete: false,
    us_state: "",
    us_state_short: "",
    us_city: "",
    us_county: "",
    checklist: [],
    loadingStore: {
      currentActivity: "Setting up your profile...",
      statusMessages: [
        {
          message: "Setting up your profile...",
          completed: false,
          inProgress: false,
        },
        {
          message: "Creating your profile...",
          completed: false,
          inProgress: false,
        },
        {
          message: "Processing location data...",
          completed: false,
          inProgress: false,
        },
        {
          message: "Prioritizing locations...",
          completed: false,
          inProgress: false,
        },
        {
          message: "Personalizing your experience...",
          completed: false,
          inProgress: false,
        },
        {
          message: "Selecting your top properties...",
          completed: false,
          inProgress: false,
        },
      ],
      showInteractiveComponent: false,
      canSkip: false,
      checkInterval: null,
      progress: 0,
      loading: false,
    },
    conversationId: "",
    conversationData: {},
  }),
  actions: {
    resetStore() {
      this.$reset(); // This resets the state to the initial state defined above
    },
    async getUser(user) {
      const db = useFirestore()
      
      const collectionRef = collection(db, "personadata");
      const docRef = doc(db, "personadata", user.uid);
      const docSnapshot = await getDoc(docRef);

      if (docSnapshot.exists()) {
        console.log("Not a New User");
        this.getPersona(user.uid);
        return true;
      } else {
        console.log("New User, no account found");
        return false;
      }
    },
    async createNewProfile(user, tempFormData) {
      console.log("Creating new profile");

      const response = await axios.post("api/profile-builder/create", {
        form: tempFormData,
        userId: user.uid,
      });

      return response.data;
    },
    async updateExistingProfile(user, tempFormData) {
      console.log("Updating existing profile", tempFormData, user.uid);
      await this.triggerProfileBuilder(tempFormData, user.uid);

      // Clear search filters
      localStorage.removeItem("propertySearchFilters");

      // Add a 2 second delay
      await new Promise(resolve => setTimeout(resolve, 2000));

    },
    setcitystatecounty(detailed_address) {
      let city = "";
      let state = "";
      let county = "";
      let stateShortCode = "";

      if (detailed_address && Array.isArray(detailed_address)) {
        detailed_address.forEach((component) => {
          if (component.types.includes("locality")) {
            city = component.long_name; // City name
            console.log(city);
          }
          if (component.types.includes("administrative_area_level_1")) {
            state = component.long_name; // State name
            stateShortCode = component.short_name; // State shortcode
            console.log(state, stateShortCode);
          }
          if (component.types.includes("administrative_area_level_2")) {
            county = component.long_name; // County name
            console.log(county);
          }
        });
      }
      this.us_city = city;
      this.us_state = state;
      this.us_state_short = stateShortCode;
      this.us_county = county;
    },
    async processNewLocation(docId) {
      try {
        const db = useFirestore()
        this.loadingStore.currentActivity =
          this.loadingStore.statusMessages[0].message;
        this.loadingStore.statusMessages[0].inProgress = true;
        console.log("Processing new location");
        // Ensure we're tracking status
        await this.fetchStatus(docId);
        // Calculate distance and create isochrone
        this.loadingStore.progress = 5;
        if (this.form.movingFrom && this.form.movingTo) {
          await this.updateStatus(docId, "Creating Travel Time Isochrone...");

          this.form.distanceMiles = await this.calculateDistance(
            this.form.movingFrom.location,
            this.form.movingTo.location
          );
          // Fetch isochrone data
          this.isoChrone = await this.getIsochrone(this.form.movingTo.location);
          // Set move type based on distance
          if (this.form.distanceMiles > 100) {
            this.form.movetype = "long-distance";
          } else if (this.form.distanceMiles > 20) {
            this.form.movetype = "mid-distance";
          } else {
            this.form.movetype = "local-move";
          }

          // Update document with form and isochrone data
          await updateDoc(doc(db, "personadata", docId), {
            form: { ...this.form },
            isochrone: JSON.stringify(this.isoChrone),
          });
        }
        this.loadingStore.progress = 10;
        this.loadingStore.currentActivity =
          this.loadingStore.statusMessages[1].message;
        this.loadingStore.statusMessages[1].inProgress = true;
        this.loadingStore.statusMessages[0].completed = true;
        this.loadingStore.statusMessages[0].inProgress = false;

        await this.setcitystatecounty(this.form.movingTo.detailed_address);

        console.log("Triggering RelData");

        const [tractData, citiesData, persona] = await Promise.all([
          this.triggerTract(docId, this.us_state),
          this.triggerCities(docId, this.us_state),
          this.createAIPersona(docId),
        ]).catch((error) => {
          console.error("Error creating AI persona:", error);
          this.loadingStore.currentActivity =
            "An error has occurred creating your AI persona";
          throw error;
        });
        this.loadingStore.progress = 50;
        this.loadingStore.currentActivity =
          this.loadingStore.statusMessages[2].message;
        this.loadingStore.statusMessages[2].inProgress = true;
        this.loadingStore.statusMessages[1].completed = true;
        this.loadingStore.statusMessages[1].inProgress = false;
        this.assumptions = persona;
        console.log("Triggering RelData -> ", tractData, citiesData);
        await this.updateStatus(docId, "Before scoring");
        const triggerScoringNeighbourhoodsPromise =
          this.triggerScoringNeighbourhoods(
            docId,
            this.us_state,
            this.us_state_short
          );

        const triggerCitiesAndTractsPromise = this.triggercitiesandtracts(
          docId,
          this.us_state
        );
        console.log("Triggering triggercitiesandtracts ran");
        this.loadingStore.statusMessages[2].inProgress = false;
        this.loadingStore.statusMessages[2].completed = true;
        console.log("Triggering scoring complete");
        this.loadingStore.statusMessages[3].inProgress = true;
        this.loadingStore.currentActivity =
          this.loadingStore.statusMessages[3].message;
        await Promise.all([
          triggerScoringNeighbourhoodsPromise,
          triggerCitiesAndTractsPromise,
        ]).catch((error) => {
          console.error("Error triggering scoring:", error);
          this.loadingStore.currentActivity =
            "An error has occurred scoring your neighborhoods";
          throw error;
        });
        this.loadingStore.statusMessages[3].inProgress = false;
        this.loadingStore.statusMessages[3].completed = true;
        console.log("Triggering scoring complete");
        this.loadingStore.statusMessages[4].inProgress = true;
        this.loadingStore.currentActivity =
          this.loadingStore.statusMessages[4].message;

        // Create checklist
        await this.updateStatus(docId, "Creating your personalized checklist");
        await this.createChecklist(this.personadocid)
          .then((response) => {
            console.log("Checklist created", response);
            this.loadingStore.statusMessages[4].inProgress = false;
            this.loadingStore.statusMessages[4].completed = true;
          })
          .catch((error) => {
            console.error("Error creating checklist:", error);
            this.loadingStore.currentActivity =
              "An error has occurred creating your checklist";
            throw error;
          });

        return {
          persona: persona,
          status: "Complete",
        };
      } catch (error) {
        console.error("Error processing location:", error);
        await this.updateStatus(docId, "Error creating new profile PS389");
        this.loadingStore.currentActivity =
          "An error has occurred fetching your data";
        throw error;
      }
    },
    async calculateDistance(coords1, coords2) {
      const toRadians = (degrees) => degrees * (Math.PI / 180);
      const R = 3958.8; // Earth radius in miles
      const dLat = toRadians(coords2.lat - coords1.lat);
      const dLon = toRadians(coords2.lng - coords1.lng);
      const a =
        Math.sin(dLat / 2) ** 2 +
        Math.cos(toRadians(coords1.lat)) *
          Math.cos(toRadians(coords2.lat)) *
          Math.sin(dLon / 2) ** 2;
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      return R * c;
    },
    async getIsochrone(coords) {
      try {
        const response = await fetch("/api/Isochrone", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ location: coords }),
        });
        const result = await response.json();
        return result.features[0];
      } catch (error) {
        console.error("Error fetching isochrone:", error);
        throw error;
      }
    },
    async createAIPersona(docId) {
      try {
        const db = useFirestore()
        const response = await fetch("/api/personacreator", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ form: this.form }),
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const responseData = await response.json();
        await updateDoc(doc(db, "personadata", docId), {
          AIAssumptions: responseData,
        });
        console.log("AI persona created", responseData);
        return responseData;
      } catch (error) {
        console.error("Error creating AI persona:", error);
        throw error;
      }
    },
    async getPersona(id) {

      const user = useCurrentUser();
      // Not ideal but this is quick fix
      let uid = id;
      if(!uid) {
        uid = user.value.uid;
      }

      try {
        const db = useFirestore()
        const docRef = doc(db, "personadata", uid);
        const document = await getDoc(docRef);

        if (document.exists()) {
          document.data();
          this.personadocid = uid;
          this.form = document.data().form;

          this.setOriginalFormState(document.data().form);
          this.assumptions = document.data().AIAssumptions?.data;
          if(document.data().checklist) {
            this.checklist = JSON.parse(document.data().checklist);
          }
          if (this.form?.movingTo?.detailed_address) {
            const stateComponent = this.form.movingTo.detailed_address.find(
              (component) =>
                component.types.includes("administrative_area_level_1")
            );
            this.us_state = stateComponent ? stateComponent.long_name : "";
          }

          if (document.data().isochrone) {
            try {
              this.isoChrone = JSON.parse(document.data().isochrone);
            } catch (error) {
              console.error("Error parsing isochrone JSON:", error);
              this.isoChrone = ""; // Set a default value or handle the error as needed
            }
          } else {
            this.isoChrone = null; // Set to null if `isochrone` does not exist
          }
        }
      } catch (error) {
        console.error("Error finding persona:", error);
      }
    },
    async createLoading(docid) {
      const db = useFirestore()
      const loading = doc(db, "personadata", docid, "Status", "CurrentState");
      await setDoc(
        loading,
        {
          loading: true,
          property_selection_completed: false,
          property_selection_triggered: false,
          user_approval_required: false,
          user_notification_required: false,
          user_replied: false,
          user_feedback: "",
          checklist_completed: false,
          checklist_triggered: false,
          citySelectionCompleted: false,
          citySelectionTriggered: false,
          FetchTractCompleted: false,
          FetchTractsTriggered: false,
          FetchZipcodeCompleted: false,
          FetchZipcodeTriggered: false,
          associate_tracts_completed: false,
          associate_tracts_triggered: false,
          neighbourhoodScoreCompleted: false,
          neighbourhoodScoreTriggered: false,
          activity: [
            {
              Activity: "Created Loading",
              Trigger: "WebApp -> createLoading",
              TimeStamp: Timestamp.now(),
            },
          ],
        },
        { merge: false }
      );
      return "status created";
    },
    async checkProfileStatus(uid) {
      try {
        const db = useFirestore()
        console.log("Checking profile status", uid);
        const docRef = doc(db, "personadata", uid);

        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          this.personadocid = docSnap.id;
          this.form = docSnap.data().form;

          this.assumptions = docSnap.data().AIAssumptions?.data;
          this.checklist = JSON.parse(docSnap.data()?.checklist || "[]");
          await this.setcitystatecounty(this.form.movingTo.detailed_address);
          return true;
        } else {
          return false;
        }
      } catch (error) {
        console.error("Error checking profile status:", error);
        throw error;
      }
    },
    async updateStatus(docid, message, status = true) {
      const db = useFirestore()
      const loading = doc(db, "personadata", docid, "Status", "CurrentState");
      await setDoc(
        loading,
        {
          loading: status,
          activity: arrayUnion({
            Activity: message,
            Trigger: "WebApp",
            TimeStamp: Timestamp.now(),
          }),
        },
        { merge: true }
      );
    },
    async fetchStatus(docid) {
      const db = useFirestore()
      const docRef = doc(db, "personadata", docid, "Status", "CurrentState");
      onSnapshot(
        docRef,
        (docSnap) => {
          if (docSnap.exists()) {
            const data = docSnap.data();
            this.status = {
              FetchTractCompleted: data.FetchTractCompleted || false,
              FetchTractsTriggered: data.FetchTractsTriggered || false,
              FetchZipcodeCompleted: data.FetchZipcodeCompleted || false,
              FetchZipcodeTriggered: data.FetchZipcodeTriggered || false,
              associate_tracts_completed:
                data.associate_tracts_completed || false,
              associate_tracts_triggered:
                data.associate_tracts_triggered || false,
              loading: data.loading !== undefined ? data.loading : true,
              neighbourhoodScoreCompleted:
                data.neighbourhoodScoreCompleted || false,
              neighbourhoodScoreTriggered:
                data.neighbourhoodScoreTriggered || false,
            };
            return this.status;
          }
          return null;
        },
        (error) => {
          console.error("Error fetching document:", error);
          throw error;
        }
      );
    },

    async setConversationId(docid, conversationId) {
      const db = useFirestore()
      await setDoc(
        doc(db, "personadata", docid),
        {
          conversation_id: conversationId,
        },
        { merge: true }
      );
    },

    async getChecklist(docid) {
      const db = useFirestore()
      const checklist_ref = doc(db, "personadata", docid);
      const checklistData = await getDoc(checklist_ref);
      return checklistData.data().checklist;
    },

    async triggerProfileBuilder(form, userId) {
      console.log("Triggering profile builder", {});

      const response = await axios.post("api/profile-builder/create", {
        form,
        userId,
      });

      console.log("Profile builder response", response.data);

      return response.data;
    },

    async triggerPhoneCallProcessing(docid, conversationId) {
      console.log(
        "Triggering phone call processing for user:",
        docid,
        "and conversationId:",
        conversationId
      );
      const response = await axios.post("api/calling/trigger-processing", {
        userId: docid,
        conversationId: conversationId,
      });
      return response.data;
    },

    deepEqual(obj1, obj2) {
      return JSON.stringify(obj1) === JSON.stringify(obj2);
    },
    setOriginalFormState(formData) {
      this.originalFormState = JSON.parse(JSON.stringify(formData));
    },
    async getConversationData() {
      console.log("getConversationData", this.personadocid);
      const db = useFirestore()
      const conversationRef = doc(db, "personadata", this.personadocid);
      const conversationData = await getDoc(conversationRef);
      console.log("conversationData", conversationData.data().conversation_id);
      const response = await axios.post("api/calling/fetch_conversation", {
        conversationId: conversationData.data().conversation_id,
      });
      return (this.conversationData = response.data);
    },
  },

  getters: {
    latestActivity: (state) => {
      console.log(
        "current status",
        Object.keys(state.status).length,
        state.status
      );

      // Check if state.status and state.status.activity are defined and not empty
      if (
        state.status &&
        state.status.activity &&
        state.status.activity.length > 0
      ) {
        // Use reduce to find the item with the latest timestamp
        return state.status.activity[state.status.activity.length - 1];
      }

      // Return null or an appropriate default if no activity exists
      return null;
    },
  },
  //Getters allow you to modify the task a bit before returning it, for instance getting all the fav tasks in a task array. The state is not changed.
});
